// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"297":"xlsx","643":"pdfmake"}[chunkId] || chunkId) + "." + {"297":"b19a54de","643":"65ca7957","959":"ef64a42f"}[chunkId] + ".chunk.js";
};